<template>
    <div class="page">
        <div class="base">
            <img src="http://img.cdboost.cn/cdboost/sy/jjfa01.jpg" alt="">
        </div>
        <div class="base" id="ID11">
            <img src="http://img.cdboost.cn/cdboost/sy/jjfa02.jpg" alt="">
        </div>
        <div class="base" id="ID12">
            <img src="http://img.cdboost.cn/cdboost/sy/jjfa03.jpg" alt="">
        </div>
        <div class="base" id="ID13">
            <img src="http://img.cdboost.cn/cdboost/sy/jjfa04.jpg" alt="">
        </div>
        <div class="base" id="ID14">
            <img src="http://img.cdboost.cn/cdboost/sy/jjfa05.jpg" alt="">
        </div>
        <div class="base" id="ID15">
            <img src="http://img.cdboost.cn/cdboost/sy/jjfa006.jpg" alt="">
        </div>
        <div class="base" id="ID16">
            <img src="http://img.cdboost.cn/cdboost/sy/jjfa07.jpg" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        name: "solution"
    }
</script>

<style scoped  lang="scss">
    .base {
        color: #333333;
        position: relative;
        overflow: hidden;
        background: white;
    }
</style>